import { IDatalayersService } from "../types";

import ICropYieldScale = omnia.models.ICropYieldScale

export class YieldScalesContext {

    public getEditedScales: () => ICropYieldScale[];
    public getRemovedScalesIds: () => number[];
    public scalesChanged: () => boolean;
    public scaleValid: () => boolean;

    public isEditing: () => boolean
    public endEdition: () => void

    public createScale: () => void

    public form: ng.IFormController;

    constructor(private datalayersSvc: IDatalayersService) {

    }

    public canCommit() {
        return this.scalesChanged && this.scalesChanged() && this.scaleValid && this.scaleValid() && (!this.form || (this.form && this.form.$valid));
    }

    public commit(): ng.IPromise<any> {

        var scales = this.getEditedScales ? this.getEditedScales() : [];
        var removedScalesIds = this.getRemovedScalesIds ? this.getRemovedScalesIds() : [];

        return this.datalayersSvc.saveYieldScales(scales, removedScalesIds)

    }
}
